<template>
  <BasicModal
    :key="'modal-detail-' + sk.id"
    :title="'　　　詳細: ' + sk.name"
    :isShowModal="isShowModal"
    :width="isFullMode ? '80vw' : '80vw'"
    :slideDirection="isFullMode ? null : 'right'"
    :slideWidth="isFullMode ? null : '75%'"
    :slideMaxWidth="isFullMode ? null : '750px'"
    :canCancel="true"
    :noOverlay="!isFullMode"
    :draggable="!isFullMode"
    @cancel="cancel">
      <!-- URLコピー用 -->
      <input type="hidden" style="opacity: 0 !important;" id="copy_code_detail" :value="singleURL"/>
      <div style="font-size: 1.2em; font-weight: bold; margin-top: -40px; margin-bottom:10px; display: flex; padding-left: 12px;">
        <div class="navigation-buttons">
          <button 
            class="nav-btn"
            @click="navigateToPrevious"
            :disabled="!canNavigatePrevious"
            title="前の応募者"
          >
            <span class="mdi mdi-chevron-up"></span>
          </button>
          <button 
            class="nav-btn"
            @click="navigateToNext"
            :disabled="!canNavigateNext"
            title="次の応募者"
          >
            <span class="mdi mdi-chevron-down"></span>
          </button>
        </div>
        <button 
          class="toggle-mode-btn"
          @click.stop.prevent="toggleMode"
          title="表示モード切替"
          style="margin-left: auto; margin-right: 12px;"
        >
          <span class="mdi mdi-arrow-expand-horizontal"></span>
          <span class="toggle-text">切替</span>
        </button>
      </div>
      <b-tabs style='padding: 0px 24px 24px 24px; margin-bottom: 0px;' v-model="currentTub">
        <b-tab-item label='詳細'>
          <div class="card-body" @click.stop>
            <div style="font-size: 1.2em; font-weight: bold; padding: 4px; display: flex;">
              <button class="button is-small" style="margin-left: auto; margin-right: 8px;" @click="outputPDF()">PDF出力</button>
              <button class="button is-small" style="margin-right: 8px;" @click="copySeekerPageURL(sk);">URLコピー</button>
            </div>
            <table class="table-box disp-scroll">
              <tr>
                <th style="width: 30%;" class="table-th">
                  項目
                </th>
                <th style="width: 70%;" class="table-th">
                  内容
                </th>
              </tr>
              <!-- 応募者管理画面振り分け -->
              <template v-if="select_manages.length > 0">
                <tr :key="select_manages.pk">
                  <td style="width: 30%;">
                    応募者管理画面<p style="font-size: smaller">※「応募者一覧」は全応募者が表示されます。</p>
                  </td>
                  <td style="width: 70%; vertical-align: middle; min-width: 150px;" :key="select_manages.pk">
                    <v-select
                      v-model="display_manage"
                      :options="select_manages"
                      label="name"
                      :reduce="name => name.pk"
                      multiple>
                    </v-select>
                  </td>
                </tr>
              </template>
              <template v-for="(col) in companyColumnSetting">
                <template v-if="!col.is_disabled">
                  <template>
                    <tr :key="col.order_type">
                      <td style="width: 30%;" v-if="col.template_type == 24">
                        重複<br>※EmailまたはTELが同じ応募者
                      </td>
                      <td style="width: 30%;" v-else-if="col.template_type !=25">
                        {{col.name}}
                      </td>
                      <!-- 管理ID -->
                      <td style="width: 100px; vertical-align: middle;" :key="col.order_type + '-col30'" v-if="col.template_type == 30">
                        <div style="display: flex; align-items: center; margin-right: 4px;">
                          {{ sk.applicant_id }}
                        </div>
                      </td>
                      <!-- 経路 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col1'" v-if="col.template_type == 1">
                        <b-tag size="is-small is-info" class="-bottom-8px" v-if="getScoutFlg(sk)">
                          {{sk.recruit_route}}
                        </b-tag>
                        <b-tag size="is-small is-primary">
                          <a target="_blank" style="color: white;" :href="getHref(sk)">
                            {{getPath(sk)}}
                          </a>
                        </b-tag>
                      </td>
                      <!-- 名前 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col2'" v-if="col.template_type == 2">
                        <div style="display: flex; align-items: center; margin-right: 4px;">
                          <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.name"/>
                        </div>
                        <p v-if="sk.duplicate_name.length" style="color: red">※名前が他の登録者と重複しています。</p>
                      </td>
                      <!-- 振り仮名 -->
                      <td style="width: 70%; vertical-align: middle; min-width: 200px;" :key="col.order_type + '-col3'" v-if="col.template_type == 3">
                        <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.name_phonetic"/>
                      </td>
                      <!-- Email -->
                      <td style="width: 70%; vertical-align: middle; min-width: 200px;" :key="col.order_type + '-col4'" v-if="col.template_type == 4">
                        <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.email"/>
                        <p v-if="sk.duplicate_email.length" style="color: red">※Emailが他の登録者と重複しています。</p>
                      </td>
                      <!-- TEL -->
                      <td style="width: 70%; vertical-align: middle; min-width: 150px;" :key="col.order_type + '-col5'" v-if="col.template_type == 5">
                        <input class="input is-small cell-textbox" style="white-space: nowrap;" v-model="sk.tel"/>
                        <p v-if="sk.duplicate_tel.length" style="color: red">※TELが他の登録者と重複しています。</p>
                      </td>
                      <!-- 生年月日 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col6'" v-if="col.template_type == 6"
                          @click="
                            $refs.editdate.changeDate=new Date(sk.birth);
                            $refs.editdate.sk=sk;
                            $refs.editdate.toggle()"
                      >
                        <p style="white-space: nowrap;">
                          {{sk.birth ? new Date(sk.birth).getFullYear() + '/' + (new Date(sk.birth).getMonth() + 1) + '/' + new Date(sk.birth).getDate()  : '設定なし'}}
                        </p>
                        <p v-if="sk.birth">{{getAge(new Date(sk.birth))}}歳</p>
                      </td>
                      <!-- 住所 -->
                      <td style="width: 70%; min-width: 200px;" :key="col.order_type + '-col7'" v-if="col.template_type == 7">
                        <textarea class="textarea is-small cell-textbox disp-scroll" v-model="sk.address"></textarea>
                      </td>
                      <!-- 応募職種 -->
                      <td style="width: 70%; min-width: 200px;" :key="col.order_type + '-col7'" v-if="col.template_type == 26">
                        <textarea class="textarea is-small cell-textbox disp-scroll" v-model="sk.apply_occupation"></textarea>
                      </td>
                      <!-- 応募職務拠点 -->
                      <td style="width: 70%; min-width: 200px;" :key="col.order_type + '-col7'" v-if="col.template_type == 27">
                        <textarea class="textarea is-small cell-textbox disp-scroll" v-model="sk.apply_location"></textarea>
                      </td>
                      <!-- 応募タイトル -->
                      <td style="width: 70%; min-width: 200px;" :key="col.order_type + '-col7'" v-if="col.template_type == 28">
                        <p style="white-space: nowrap;">{{sk.apply_recruit_title}}</p>
                      </td>
                      <!-- ファイル -->
                      <td style="width: 70%;" :key="col.order_type + '-col8'" v-if="col.template_type == 8">
                        <div style="min-width: 200px; height: 100%; overflow-y: scroll; display: block;">
                          <template v-if="sk.seeker_files">
                            <div class="file-box" :key="j + '-col9'" v-for="(f, j) in sk.seeker_files">
                              <span class="mdi mdi-close" @click="changeModalDelete({flg: true, seeker: sk, seekerFile: f})"></span>
                              <img src="@/assets/template/person.png"/>
                              <span class="file-link" @click="openFileModal(f, $event)">
                                {{f.name}}
                              </span>
                            </div>
                          </template>
                          <div style="display: flex;">
                            <b-upload v-model="addFile">
                              <a class="button is-small" style="width: 90px; border: solid 1.5px #d6d; border-radius: 0;" @click="fileUpSk = sk">+ ファイル</a>
                            </b-upload>
                          </div>
                        </div>
                      </td>
                      <!-- 性別 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col10'" v-if="col.template_type == 9">
                        <select class="select" v-model="sk.sex">
                          <option v-for="(s, key) in sexTypes" :value="key" :key="key + '-col11'">
                            {{ s }}
                          </option>
                        </select>
                      </td>
                      <!-- 状況 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col12'" v-if="col.template_type == 10">
                        <select class="select" v-model="sk.progress_rate">
                          <option v-for="option in options" v-bind:value="option.value" :key="option.value + '-col13'">
                              {{ option.text }}
                          </option>
                        </select>
                      </td>
                      <!-- 応募日 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col14'" v-if="col.template_type == 11">
                        <p style="white-space: nowrap;">{{getDate(sk.subscribe_date)}}</p>
                      </td>
                      <!-- 応募回数 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col15'" v-if="col.template_type == 12">
                        {{sk.subscribe_count}}回
                      </td>
                      <!-- 備考 -->
                      <td style="width: 70%; min-width: 250px;" :key="col.order_type + '-col16'" v-if="col.template_type == 13">
                        <textarea class="textarea is-small cell-textbox disp-scroll" v-model="sk.message"></textarea>
                      </td>
                      <!-- 学歴/職歴 -->
                      <td style="width: 70%; min-width: 360px; vertical-align: middle;" :key="col.order_type + '-col17'" v-if="col.template_type == 14">
                        <div style="min-width: 350px; overflow-y: scroll; display: block;">
                          <template v-for="(ca, j) in sk.career">
                            <div style="display: flex; align-items: center; font-size: smaller; border-bottom: dotted thin #ccc; margin-bottom: 4px; margin-right: 8px; margin-left: 8px;" :key="j" v-if="sk.career.length > 0">
                              <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; width: 48px;" v-model="ca.career_year">年
                              <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; width: 48px;" v-model="ca.career_month">月
                              <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none; width: calc(100% - 96px); text-align: left;" v-model="ca.career_body">
                            </div>
                          </template>
                          <button class="button is-small" style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;" @click="$store.dispatch('directtalk/createCareer', {career_year: '', career_month: '', career_body: '', seeker: sk.id})">+ 追加</button>
                        </div>
                      </td>
                      <!-- 資格 -->
                      <td style="width: 70%; min-width: 360px; vertical-align: middle;" :key="col.order_type + '-col19'" v-if="col.template_type == 15">
                        <div style="min-width: 350px; overflow-y: scroll; display: block;">
                          <template v-for="(qu, j) in sk.qualification">
                            <div style="display: flex; align-items: center; font-size: smaller; border-bottom: dotted thin #ccc; margin-bottom: 4px; margin-right: 8px; margin-left: 8px;" :key="j" v-if="sk.qualification.length > 0">
                              <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none;  width: 48px;" v-model="qu.qualification_year">年
                              <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none;  width: 48px;" v-model="qu.qualification_month">月
                              <input class="input is-small" style="background: transparent; border: none; border-radius: 0; -webkit-appearance: none; box-shadow: none;  width: calc(100% - 96px); text-align: left;" v-model="qu.qualification_body">
                            </div>
                          </template>
                          <button class="button is-small" style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;" @click="$store.dispatch('directtalk/createQualification', {qualification_year: '', qualification_month: '', qualification_body: '', seeker: sk.id})">+ 追加</button>
                        </div>
                      </td>
                      <!-- スカウト -->
                      <td style="width: 70%;" :key="col.order_type + '-col20'" v-if="col.template_type == 16">
                        <template v-if="sk.scout_mail_flg">送付済み</template>
                        <template v-else></template>
                      </td>
                      <!-- 連携ID -->
                      <td :key="col.order_type + '-col21'" v-if="col.template_type == 17">
                        <input class="input is-small cell-textbox" v-model="sk.job_offer_no"/>
                      </td>
                      <!-- 採用フロー:ステージ -->
                      <td style="width: 70%; vertical-align: middle;"
                        :key="col.order_type + '-col22'"
                        v-if="col.template_type == 19">
                        <template v-if="recruitmentFlows.length > 0">
                          <select class="select"
                            v-model="sk.recruitment_flow_stage"
                            @change="changeRecruitmentFlow(sk)">
                            <option v-for="(stg, keyStg) in recruitmentFlows[0].stages" 
                              v-bind:value="stg.pk" 
                              :key="keyStg + '-col22'">
                                {{ stg.name }}
                            </option>
                          </select>
                        </template>
                      </td>
                      <!-- 採用フロー:ステータス -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col23'" v-if="col.template_type == 20">
                        <template v-if="recruitmentFlows.length > 0">
                          <select class="select" v-model="sk.recruitment_flow_status" @change="changeRecruitmentFlow(sk)" :disabled="!getRecruitmentFlowStatus(sk.recruitment_flow_stage)">
                            <option v-for="(sts, keySts) in getRecruitmentFlowStatus(sk.recruitment_flow_stage)" v-bind:value="sts.pk" :key="keySts + '-col24'">
                                {{ sts.name }}
                            </option>
                          </select>
                        </template>
                      </td>
                      <!-- 採用フロー:アクション -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col25'" v-if="col.template_type == 21">
                        <template v-if="recruitmentFlows.length > 0">
                          <template v-if="sk.recruitment_flow_status">
                            <ActionSet
                              :skProp="sk"
                              :actionProp="getRecruitmentFlowActions(sk.recruitment_flow_status)"
                              @openActionCheckModal="openActionCheckModal"
                              @openActionTableModal="openActionTableModal"
                            />
                          </template>
                          <template v-else>
                            -
                          </template>
                        </template>
                      </td>
                      <!-- カスタムカラム -->
                      <td style="width: 70%; overflow: hidden; vertical-align: middle;" :key="col.order_type + '-col26'" v-if="col.template_type == 0">
                        <template v-for="c in sk.custom_column">
                          <template v-if="col.is_multiline && col.is_pulldown_flg == 0">
                            <textarea
                              class="textarea is-small cell-textbox disp-scroll"
                              v-model="c.content"
                              @change="updateCustomColumnByCell(sk, c)"
                              :key="c.pk + '-col271'"
                              v-if="isLastCol(sk, col, c)"
                            >
                            </textarea>
                          </template>
                          <template v-else-if="col.is_pulldown_flg == 1">
                            <select
                              :key="c.pk + '-col272'"
                              class="select"
                              v-model="c.content"
                              @change="updateCustomColumnByCell(sk, c)"
                              v-if="isLastCol(sk, col, c)"
                            >
                              <option value="">選択してください</option>
                              <option
                                v-for="option in getOptionsForColumnModal(col.pk)"
                                :value="option.name"
                                :key="option.id"
                              >
                                {{ option.name }}
                              </option>
                            </select>
                          </template>
                          <template v-else-if="col.type_for_custom_column == 3">
                            <input
                              type="date"
                              class="input is-small"
                              v-model="c.content"
                              @change="updateCustomColumnByCell(sk, c, $event.target.value)"
                              :key="c.pk + '-col27'"
                              v-if="isLastCol(sk, col, c)"
                            />
                          </template>
                          <template v-else>
                            <input
                              class="input is-small cell-textbox"
                              v-model="c.content"
                              @change="updateCustomColumnByCell(sk, c)"
                              :key="c.pk + '-col273'"
                              v-if="isLastCol(sk, col, c) && !col.is_multiline"
                            />
                          </template>
                        </template>
                        <button
                          class="button is-small"
                          style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;"
                          @click.once="createCustomColumn(sk, col)"
                          v-if="!isColInSkInfo(sk, col) && col.is_pulldown_flg == 0 && col.type_for_custom_column != 3">
                          + 作成
                        </button>
                        <select
                          class="select"
                          v-if="!isColInSkInfo(sk, col) && col.is_pulldown_flg == 1"
                          @change="handleSelectChange($event, sk, col)"
                        >
                          <option value="" disabled selected>選択してください</option>
                          <option
                            v-for="option in getOptionsForColumn(col.pk)"
                            :value="option.name"
                            :key="option.id"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                        <template v-if="!isColInSkInfo(sk, col) && col.type_for_custom_column == 3">
                          <input
                            type="date"
                            @change="handleSelectChange($event, sk, col)"
                          />
                        </template>
                      </td>
                      <!-- 面接予定日 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col28'" v-if="col.template_type == 22">
                        <p style="text-align: left; white-space: pre-wrap;" v-if="getInterviewDate(sk.interview_history) != '未設定（仮予定あり）'">{{getInterviewDate(sk.interview_history)}}</p>
                        <a class="name" @click="changeModalSetDate(true, sk)" v-else>{{getInterviewDate(sk.interview_history)}}</a>
                      </td>
                      <!-- 録画面接 -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col29'" v-if="col.template_type == 23">
                        <button
                          class="button is-small"
                          style="border-radius: 0; margin-top: 4px; border: solid 1.5px #d6d;"
                          @click="viewAnswer(sk)"
                        >
                          回答閲覧
                        </button>
                      </td>
                      <!-- フラグ -->
                      <td style="width: 70%; vertical-align: middle;" :key="col.order_type + '-col30'" v-if="col.template_type == 24">
                        <div v-if="duplicatedApplicants(sk).length">
                          <template v-for="(dsk) in duplicatedApplicants(sk)">
                            <div :key="dsk.id + '-sk'" style="display: flex; align-items: center; margin-right: 4px;">
                              <a @click="changeModalDetailSeekerSetData(dsk)">
                              応募日：{{formatCreatedAt(dsk.subscribe_date)}} 　 {{dsk.name}}
                              </a>
                            </div>
                          </template>
                        </div>
                        <div v-else>
                          なし
                        </div>
                      </td>
                      <!-- 媒体連携資格 -->
                      <td style="width: 70%; min-width: 250px;" :key="col.order_type + '-col31'" v-if="col.template_type == 29">
                        <textarea class="textarea is-small cell-textbox disp-scroll" v-model="sk.recruitment_media_qualification"></textarea>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </table>
          </div>
        </b-tab-item>
        <b-tab-item label='変更履歴'>
          <div class="card-body" v-if="getSubscribeChangeHistory" @click.stop>
            <table class="table-box disp-scroll">
              <tr>
                <th style="width: 20%;" class="table-th">
                  項目
                </th>
                <th style="width: 20%;" class="table-th">
                  変更前
                </th>
                <th style="width: 20%;" class="table-th">
                  変更後
                </th>
                <th style="width: 20%;" class="table-th">
                  変更者
                </th>
                <th style="width: 20%;" class="table-th">
                  変更日時
                </th>
              </tr>
              <tr v-for="(history, idx) in getSubscribeChangeHistory" :key="idx">
                <td style="width: 20%; vertical-align: middle;">
                  <p class="history">{{history.column_name}}</p>
                </td>
                <td style="width: 20%; vertical-align: middle;">
                  <p class="history">{{history.before_content}}</p>
                </td>
                <td style="width: 20%; vertical-align: middle;">
                  <p class="history">{{history.after_content}}</p>
                </td>
                <td style="width: 20%; vertical-align: middle;">
                  <p class="history">{{history.updater}}</p>
                </td>
                <td style="width: 20%; vertical-align: middle;">
                  <p class="history">{{getDate(history.created_at)}}</p>
                </td>
              </tr>
            </table>
          </div>
          <div class="card-body" v-else>
            変更履歴はありません
          </div>
        </b-tab-item>
        <b-tab-item label="メール送付">
          <div class="card-body disp-scroll" @click.stop>
            <MailAction
              class='mail-action disp-scroll'
              :seeker="sk"
              :isOpenEmailMenu="true"
              :bulk="false"
              :chatbots="this.dataForMailAction.chatbots"
              :recordingInterviews="this.dataForMailAction.recordingInterviews"
              :users="this.dataForMailAction.users"
              :options="this.dataForMailAction.options"
              :sendLoadding="this.dataForMailAction.sendLoadding"
              :emailTemplates="this.dataForMailAction.emailTemplates"
              :sendEmailTemplate="this.dataForMailAction.sendEmailTemplate"
              :changeEmailTemplate="this.dataForMailAction.changeEmailTemplate"
              :sendEmailToSeeker="this.dataForMailAction.sendEmailToSeeker"
              :copyLink="this.dataForMailAction.copyLink"
            />
          </div>
        </b-tab-item>
        <b-tab-item label="詳細シート">
          <div class="card-body" @click.stop>
            <DetailSheet
              ref="detailSheet"
              :seeker="sk"
              :sexTypes="sexTypes"
              :progressOptions="options"
              :getInterviewDate="getInterviewDate"
              :getMediaName="getPath"
              :copySeekerPageURL="copySeekerPageURL"
              :options="options"
              :companyColumnSetting="companyColumnSetting"
              :user="user"
              :updateSeeker="updateSeeker"
              :updateCustomColumnByCell="updateCustomColumnByCell"
              :isLastCol="isLastCol"
              :createCustomColumn="createCustomColumn"
              :isColInSkInfo="isColInSkInfo"
              :pageUpdate="pageUpdate"
              :pulldownOptionsByColumnId="pulldownOptionsByColumnId"
              :getOptionsForColumn="getOptionsForColumn"
              :getOptionsForColumnModal="getOptionsForColumnModal"
              :handleSelectChange="handleSelectChange"
            />
          </div>
        </b-tab-item>
      </b-tabs>
    <!-- フッターアクション -->
    <footer class="footer" style="padding-bottom:0px">
      <div class="footer-box">
        <button class="button" @click="cancel">キャンセル</button>
        <button class="button is-primary" @click="save" v-show="currentTub == 0">
          保存する
        </button>
        <button class="button is-primary" @click="saveFreeInputs" v-show="currentTub == 3 && !this.$refs.detailSheet.isLoading && this.$refs.detailSheet.selectedTemplate">
          保存する
        </button>
        <button class="button" @click="backSheetList" v-show="currentTub == 3 && !this.$refs.detailSheet.isLoading && this.$refs.detailSheet.selectedTemplate">戻る</button>
      </div>
    </footer>
    <slot></slot>
    <ModalEditDate @saveDate="saveDate" ref="editdate" :PCTRLLOG="CTRLLOG"/>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import createUUID from '@/functions/createUUID'
import ModalEditDate      from '@/components/ui/ModalEditDate'
import ActionSet      from '@/components/molecules/fields/ActionSet'
import moment from 'moment'
import MailAction from '@/components/Manage/MailAction'
import DetailSheet from '@/components2/Manage/modal/DetailSheet'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal,
    ModalEditDate,
    ActionSet,
    MailAction,
    DetailSheet,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    companyColumnSetting: {
      type: Array,
      required: false
    },
    recruitmentFlows: {
      type: Array,
      required: false
    },
    select_manages: {
      type: Array,
      required: false
    },
    detailManage: {
      type: Array,
      required: false
    },
    default_manage:{
      type: Object,
      required: false
    },
    currentManage: {
      type: Number
    },
    sk: {
      type: Object,
      required: false
    },
    filteredSeekers: {
      type: Array,
      required: false
    },
    navigateSeeker: {
      type: Function,
      required: false
    },
    options: {
      type: Array,
      required: false
    },
    sexTypes: {
      type: Array,
      required: false
    },
    updateSeeker: {
      type: Function,
      required: true
    },
    getScoutFlg: {
      type: Function,
      required: true
    },
    getPath: {
      type: Function,
      required: true
    },
    getAge: {
      type: Function,
      required: true
    },
    getHref: {
      type: Function,
      required: true
    },
    editdate: {
      type: Object,
      required: true
    },
    changeModalDelete: {
      type: Function,
      required: true
    },
    changeModalSetDate: {
      type: Function,
      required: true
    },
    edit: {
      type: Object,
      required: true
    },
    getDate: {
      type: Function,
      required: true
    },
    changeRecruitmentFlow: {
      type: Function,
      required: true
    },
    getRecruitmentFlowStatus: {
      type: Function,
      required: true
    },
    updateCustomColumnByCell: {
      type: Function,
      required: true
    },
    isLastCol: {
      type: Function,
      required: true
    },
    createCustomColumn: {
      type: Function,
      required: true
    },
    isColInSkInfo: {
      type: Function,
      required: true
    },
    getInterviewDate: {
      type: Function,
      required: true
    },
    viewAnswer: {
      type: Function,
      required: true
    },
    getRecruitmentFlowActions: {
      type: Function,
      required: true
    },
    saveDate: {
      type: Function,
      required: true
    },
    pageUpdate: {
      type: Function,
      required: true
    },
    duplicatedApplicants: {
      type: Function,
      required: true
    },
    changeModalDetailSeeker: {
      type: Function,
      required: true
    },
    formatCreatedAt: {
      type: Function,
      required: true
    },
    dataForMailAction: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: false
    },
    // 応募者重複表示フラグ
    isDuplicateSeekerFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGetRoboTalk: {
      type: Boolean,
      required: false,
      default: false,
    },
    pulldownOptionsByColumnId: {
      type: Object,
      required: true
    },
    getOptionsForColumn: {
      type: Function,
      required: true
    },
    handleSelectChange: {
      type: Function,
      required: true
    },
    initialFullMode: {
      type: Boolean,
      default: false
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD')
    }
  },
  watch: {
    addFile () {
      let reader = new FileReader()
      reader.onload = (e) => {
        let createFiles = new FormData()
        createFiles.append('file', this.addFile, createUUID() + this.addFile.name)
        createFiles.append('name', this.addFile.name)
        createFiles.append('seeker', this.sk.id)
        this.$store.dispatch('directtalk/createSeekerFiles', createFiles)
      }
      reader.readAsDataURL(this.addFile)
    },
    'sk.email' () {
      this.dataForMailAction.sendEmailTemplate.to_email = this.sk.email
    },
    'sk.id' () {
      // 応募者が切り替わった時に変更履歴を更新
      if (this.sk && this.sk.id) {
        this.$store.dispatch('directtalk/getSubscribeChangeHistory', this.sk.id)
          .then((history) => {
            if (history.length > 0) {
              this.subscribeChangeHistory = history
            } else {
              this.subscribeChangeHistory = null
            }
          })
          
        // display_manageも更新
        const getSeekerDetailManage = {
          company_id: this.sk.group,
          manage_id: this.sk.manage,
        }
        this.$store.dispatch('directtalk/getSeekerDetailManage', getSeekerDetailManage)
          .then(() => {
            this.display_manage = this.detailManage
          })
      }
    }
  },
  data () {
    return {
      addFile: null,
      singleURL: null,
      display_manage: [],
      subscribeChangeHistory: null,
      isFullMode: false,
      mapColumnTypeToSeekerAttribute: {
        1: seeker => seeker.recruit_route || this.getPath(seeker),
        2: seeker => seeker.name,
        3: seeker => seeker.name_phonetic,
        4: seeker => seeker.email,
        5: seeker => seeker.tel,
        6: seeker => seeker.birth ? moment(new Date(seeker.birth)).format('YYYY/MM/DD') : '設定なし',
        7: seeker => seeker.address,
        8: seeker => seeker.seeker_files.map((file)=>file.name).join('\n'),
        9: seeker => this.sexTypes[seeker.sex],
        10: seeker => this.progressOptions.find((po)=>po.value==seeker.progress_rate).text,
        11: seeker => seeker.subscribe_date ? moment(new Date(seeker.subscribe_date)).format('YYYY/MM/DD(dd)') : '',
        12: seeker => seeker.subscribe_count,
        13: seeker => seeker.message,
        14: seeker => seeker.career.map((ca)=>ca.career_year+'年 '+ca.career_month+'月\t\t'+ca.career_body).join('\n'),
        15: seeker => seeker.qualification.map((qf)=>qf.qualification_year+'年 '+qf.qualification_month+'月\t\t'+qf.qualification_body).join('\n'),
        16: seeker => seeker.scout_mail_flg ? '送付済み' : '',
        17: seeker => seeker.job_offer_no,
        18: seeker => '',//外部媒体
        19: seeker => this.recruitmentFlows[0].stages.find((stage)=>stage.pk==seeker.recruitment_flow_stage).name,
        20: seeker => this.recruitmentFlows[0].stages.find((stage)=>stage.pk==seeker.recruitment_flow_stage).status.find((stat)=>stat.pk==seeker.recruitment_flow_status).name,
        21: seeker => seeker.recruitment_flow_action_history.at(-1).action_data.name,
        22: seeker => this.getInterviewDate(seeker.interview_history),
        23: seeker => '',//回答履歴
        24: seeker => '',//フラグ
      },
      currentTub: 0,
    }
  },
  async created (){
    const getSeekerDetailManage = {
      company_id: this.sk.group,
      manage_id: this.sk.manage,
    }
    await this.$store.dispatch('directtalk/getSeekerDetailManage',getSeekerDetailManage)
    this.display_manage = this.detailManage
  },
  mounted () {
    this.isFullMode = this.initialFullMode
    this.$store.dispatch('directtalk/getSubscribeChangeHistory', this.sk.id)
      .then((history) => {
        if (history.length > 0) {
          this.subscribeChangeHistory = history
        } else {
          this.subscribeChangeHistory = null
        }
      })
  },
  computed: {
    getSubscribeChangeHistory () {
      return this.subscribeChangeHistory
    },
    currentSeekerIndex() {
      if (!this.sk || !this.filteredSeekers) return -1
      return this.filteredSeekers.findIndex(seeker => seeker.id === this.sk.id)
    },
    canNavigatePrevious() {
      return this.currentSeekerIndex > 0
    },
    canNavigateNext() {
      return this.currentSeekerIndex >= 0 && this.currentSeekerIndex < this.filteredSeekers.length - 1
    }
  },
  methods: {
    // モーダル用に列のオプションを取得
    getOptionsForColumnModal(columnId) {
      return this.getOptionsForColumn(columnId);
    },
    save() {
      this.display_manage.push(this.default_manage.pk)
      
      // 生年月日のタイムゾーン処理を追加
      // propsを直接変更しないように深いコピーを作成
      const seekerData = JSON.parse(JSON.stringify(this.sk))
      seekerData.manage = this.display_manage
      
      if (seekerData.birth) {
        // ISO文字列やDateオブジェクトから日付部分のみを抽出
        const birthDate = new Date(seekerData.birth)
        const year = birthDate.getFullYear()
        const month = String(birthDate.getMonth() + 1).padStart(2, '0')
        const day = String(birthDate.getDate()).padStart(2, '0')
        // バックエンドが期待する形式（YYYY-MM-DD）で送信
        seekerData.birth = `${year}-${month}-${day}`
      }
      
      this.sendControlLog('応募者詳細画面 保存', '応募者詳細画面にて、「保存する」ボタンをクリックした。')
      this.updateSeeker(seekerData)
      this.$emit('cancel', null, false)
    },
    cancel () {
      this.$emit('cancel', null, false)
    },
    toggleMode() {
      // モードを切り替える
      this.isFullMode = !this.isFullMode
    },
    navigateToPrevious() {
      if (this.navigateSeeker && this.canNavigatePrevious) {
        this.navigateSeeker('prev')
      }
    },
    navigateToNext() {
      if (this.navigateSeeker && this.canNavigateNext) {
        this.navigateSeeker('next')
      }
    },
    openActionCheckModal (data) {
      this.$emit('open-action-check-modal', data)
    },
    openActionTableModal (data) {
      this.$emit('open-action-table-modal', data)
    },
    async changeModalDetailSeekerSetData(sk) {
      this.cancel()
      try {
        const uh = this.user.userHash.replace(/-/g,'')
        const res = await this.$store.dispatch(
          'directtalk/getSeekerOne',
          {
            "id": sk.id,
            "uid": uh,
            "is_duplicate_seeker_flag": this.isDuplicateSeekerFlag,
            "is_get_robo_talk": this.isGetRoboTalk
          }
        )
        if(res.data.error==1) {
          alert(res.data.message)
        } else {
          this.changeModalDetailSeeker(res.data, true)
        }
      } catch(e) {
        console.error(e)
        alert('エラーが発生いたしました。')
      }
    },
    outputPDF () {
      let getContent = function (column) {
        if (column.template_type == 0) {
          let custom = this.sk.custom_column.find((col) => col.column==column.pk)
          if (custom) return custom.content
          else return ''
        }
        else {
          try {
            return this.mapColumnTypeToSeekerAttribute[column.template_type](this.sk) || ''
          }
          catch (err) {
            return ''
          }
        }
      }.bind(this)

      let data = {
        title: this.sk.name,
        table: this.companyColumnSetting
                .filter((column) => !column.is_disabled)
                .map((column) => {
                  return [column.name, getContent(column)]
                })
      }

      this.$store.dispatch('directtalk/outputSeekerPDF', data)
      .then((d) => {
        let element = document.createElement('a')
        let blob = new Blob([d.request.response], { type: d.headers['content-type'] })
        element.href = window.URL.createObjectURL(blob)
        element.download = '応募者詳細 - ' + this.sk.name +'.pdf'
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
      })
    },
    getDirectDetailSeekerURL(sk) {
      if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:8080/client/manage?sk=' + sk
      } else if (process.env.NODE_ENV === 'staging') {
        return 'https://w2.ndr-staging.work/client/manage?sk='+sk
      } else if (process.env.NODE_ENV === 'third') {
        return 'https://robottte.hr-monster.io/client/manage?sk='+sk
      } else {
        return 'https://hr-monster.io/client/manage?sk='+sk
      }
    },
    // 応募者情報リンク取得
    copySeekerPageURL (seeker) {
      this.singleURL = process.env.OWN_ENDPOINT + '/client/manage?sk=' + seeker.id
      this.$nextTick(() => {
        let codeToCopy = document.querySelector('#copy_code_detail')
        codeToCopy.setAttribute('type', 'text')
        codeToCopy.select()
        document.execCommand('copy')
        this.$buefy.snackbar.open({
          message: '応募者情報URLをコピーしました！',
          type: 'is-success',
          position: 'is-top',
          actionText: 'OK',
          indefinite: true
        })
        codeToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      })
    },
    backSheetList() {
      this.$refs.detailSheet.selectTemplate(undefined)
    },
    saveFreeInputs() {
      this.$refs.detailSheet.saveFreeInputs()
    },
    // 各応募者の保有しているファイルのプレビューを開くモーダル
    openFileModal(file) {
      this.$emit('open-file', file, event);
    },
  }
}
</script>

<style lang="scss" scoped>
.toggle-mode-btn {
  background: white;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 14px;
  color: #363636;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    border-color: #b5b5b5;
    background: #f5f5f5;
  }
  
  .mdi {
    font-size: 16px;
  }
  
  .toggle-text {
    font-size: 12px;
  }
}

.navigation-buttons {
  display: flex;
  gap: 6px;
}

.nav-btn {
  background: white;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
  color: #363636;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 34px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  
  &:hover:not(:disabled) {
    border-color: #3273dc;
    background: #f0f7ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  }
  
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: #f8f9fa;
    border-color: #e9ecef;
    color: #adb5bd;
    box-shadow: none;
  }
  
  .mdi {
    font-size: 18px;
  }
}

::v-deep .modal-background {
  background-color: rgba(0, 0, 0, 0.5);
}

.card-body {
  //overflow: auto;
  height: 60vh;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.input-field {
  padding: 8px;
  p {
    font-weight: 600;
    margin-bottom: 4px;
  }
}
.table-box {
  display: block;
  height: 100%;
  width: 100%;
  tr {
    display: table;
    width: 100%;
    td {
      padding: 8px;
      height: auto;
      min-height: 36px;
    }
  }
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  textarea {
    border: dotted thin #ccc;
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.table-th {
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.file-box {
  font-size: smaller;
  overflow: hidden;
  width: 100%;
  height: 24px;
  display: inline-flex;
  margin-bottom: 4px;
  img {
    width: 16px; height: 16px; margin-right: 4px;
  }
  span {
    cursor: pointer; color: red; margin-right: 8px;
  }
  a {
    display: block;
    width: 150px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.footer {
  bottom: 0;
  padding: 2vh;
  border-radius: 8px;
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 32%;
  }
}

.mail-action {
  position: relative !important;
  top: auto !important;
  right: auto !important;
  width: 50% !important;
  margin-left: auto;
  margin-right: auto;
}
.history {
  text-align: left;
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// src/components/Manage/ModalDetailSeeker.vue